var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isShowAddNodeInstruction,
            title: _vm.$t("Notification"),
            width: "720px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowAddNodeInstruction = $event
            }
          }
        },
        [
          _c("div", {
            staticClass: "content markdown-body",
            domProps: { innerHTML: _vm._s(_vm.addNodeInstructionHtml) }
          })
        ]
      ),
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Node List") } },
            [
              _c(
                "div",
                { staticClass: "filter-wrapper" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "success",
                        icon: "el-icon-plus"
                      },
                      on: { click: _vm.onAddNode }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Add Node")) + " ")]
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: _vm.filteredTableData,
                    "header-cell-style": {
                      background: "rgb(48, 65, 86)",
                      color: "white"
                    },
                    border: ""
                  },
                  on: {
                    "row-click": _vm.onRowClick,
                    "expand-change": _vm.onRowExpand
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "expand" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form",
                              {
                                staticClass: "node-detail",
                                attrs: {
                                  model: scope.row,
                                  "label-width": "120px",
                                  inline: ""
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t("OS") } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.systemInfo
                                            ? _vm.getOSName(
                                                scope.row.systemInfo.os
                                              )
                                            : ""
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t("ARCH") } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.systemInfo
                                            ? scope.row.systemInfo.arch
                                            : ""
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t("Number of CPU") } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.systemInfo
                                            ? scope.row.systemInfo.num_cpu
                                            : ""
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form",
                              {
                                staticClass: "node-detail executable",
                                attrs: {
                                  model: scope.row,
                                  "label-width": "120px"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t("Executables") } },
                                  [
                                    true
                                      ? _c(
                                          "ul",
                                          { staticClass: "executable-list" },
                                          _vm._l(
                                            _vm.getExecutables(scope.row),
                                            function(ex, index) {
                                              return _c(
                                                "li",
                                                {
                                                  key: index,
                                                  staticClass: "executable-item"
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        content: ex.path
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        [
                                                          ex.file_name.match(
                                                            /^python/
                                                          )
                                                            ? [
                                                                _c(
                                                                  "font-awesome-icon",
                                                                  {
                                                                    attrs: {
                                                                      icon: [
                                                                        "fab",
                                                                        "python"
                                                                      ]
                                                                    }
                                                                  }
                                                                )
                                                              ]
                                                            : ex.file_name.match(
                                                                /^java/
                                                              )
                                                            ? [
                                                                _c(
                                                                  "font-awesome-icon",
                                                                  {
                                                                    attrs: {
                                                                      icon: [
                                                                        "fab",
                                                                        "java"
                                                                      ]
                                                                    }
                                                                  }
                                                                )
                                                              ]
                                                            : ex.file_name.match(
                                                                /^bash$|^sh$/
                                                              )
                                                            ? [
                                                                _c(
                                                                  "font-awesome-icon",
                                                                  {
                                                                    attrs: {
                                                                      icon: [
                                                                        "fab",
                                                                        "linux"
                                                                      ]
                                                                    }
                                                                  }
                                                                )
                                                              ]
                                                            : ex.file_name.match(
                                                                /^node/
                                                              )
                                                            ? [
                                                                _c(
                                                                  "font-awesome-icon",
                                                                  {
                                                                    attrs: {
                                                                      icon: [
                                                                        "fab",
                                                                        "node-js"
                                                                      ]
                                                                    }
                                                                  }
                                                                )
                                                              ]
                                                            : ex.file_name.match(
                                                                /^php/
                                                              )
                                                            ? [
                                                                _c(
                                                                  "font-awesome-icon",
                                                                  {
                                                                    attrs: {
                                                                      icon: [
                                                                        "fab",
                                                                        "php"
                                                                      ]
                                                                    }
                                                                  }
                                                                )
                                                              ]
                                                            : [
                                                                _c(
                                                                  "font-awesome-icon",
                                                                  {
                                                                    attrs: {
                                                                      icon: [
                                                                        "fas",
                                                                        "terminal"
                                                                      ]
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "executable-label"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  ex.display_name
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._l(_vm.columns, function(col) {
                    return [
                      col.name === "status"
                        ? _c("el-table-column", {
                            key: col.name,
                            attrs: {
                              label: _vm.$t(col.label),
                              sortable: col.sortable,
                              width: col.width
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.status === "offline"
                                        ? _c(
                                            "el-tag",
                                            { attrs: { type: "info" } },
                                            [_vm._v(_vm._s(_vm.$t("Offline")))]
                                          )
                                        : scope.row.status === "online"
                                        ? _c(
                                            "el-tag",
                                            { attrs: { type: "success" } },
                                            [_vm._v(_vm._s(_vm.$t("Online")))]
                                          )
                                        : _c(
                                            "el-tag",
                                            { attrs: { type: "danger" } },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("Unavailable"))
                                              )
                                            ]
                                          )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        : col.name === "type"
                        ? _c("el-table-column", {
                            key: col.name,
                            attrs: {
                              label: _vm.$t(col.label),
                              sortable: col.sortable,
                              width: col.width
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.is_master
                                        ? _c(
                                            "el-tag",
                                            { attrs: { type: "primary" } },
                                            [_vm._v(_vm._s(_vm.$t("Master")))]
                                          )
                                        : _c(
                                            "el-tag",
                                            { attrs: { type: "warning" } },
                                            [_vm._v(_vm._s(_vm.$t("Worker")))]
                                          )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        : _c("el-table-column", {
                            key: col.name,
                            attrs: {
                              property: col.name,
                              label: _vm.$t(col.label),
                              sortable: col.sortable,
                              align: col.align || "left",
                              width: col.width
                            }
                          })
                    ]
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("Action"),
                      align: "left",
                      width: "160",
                      fixed: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t("View"),
                                  placement: "top"
                                }
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-search",
                                    size: "mini"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onView(scope.row)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t("Remove"),
                                  placement: "top"
                                }
                              },
                              [
                                scope.row.status !== "online"
                                  ? _c("el-button", {
                                      attrs: {
                                        type: "danger",
                                        icon: "el-icon-delete",
                                        size: "mini"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.onRemove(scope.row)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "pagination" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.pagination.pageNum,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.pagination.pageSize,
                      layout: "sizes, prev, pager, next",
                      total: _vm.nodeList.length
                    },
                    on: {
                      "update:currentPage": function($event) {
                        return _vm.$set(_vm.pagination, "pageNum", $event)
                      },
                      "update:current-page": function($event) {
                        return _vm.$set(_vm.pagination, "pageNum", $event)
                      },
                      "update:pageSize": function($event) {
                        return _vm.$set(_vm.pagination, "pageSize", $event)
                      },
                      "update:page-size": function($event) {
                        return _vm.$set(_vm.pagination, "pageSize", $event)
                      },
                      "current-change": _vm.onPageChange,
                      "size-change": _vm.onPageChange
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Installation") } },
            [
              _c("node-installation-matrix", {
                attrs: { "active-tab": _vm.activeTab }
              })
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Network") } },
            [_c("node-network", { attrs: { "active-tab": _vm.activeTab } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }